<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 id="js-modal-title" class="modal-title">{{TR "Werte auswählen"}}</h4>
</div>

<div class="modal-body">
    {{#unless selectedCategoryID}}
    <div class="row">
        <div class="col-xs-12 col-sm-6 m-b-10">
            {{TR "Geräteauswahl"}}:
        </div>
        <div class="col-xs-12 col-sm-6">
            {{#SELECT selectedCategoryID}}
            <select
                id="js-category-select"
                class="selectpicker"
                data-live-search="true"
                data-style="btn-white"
                data-title="{{TR 'Gerätetyp auswählen'}}">
                {{#each categories}}
                    <option value="{{name}}">{{TYPE_DEVICE category type}} ({{deviceCount}}
                    {{#COMPARE deviceCount '==' 1}}{{TR 'Gerät'}}{{else}}{{TR 'Geräte'}}{{/COMPARE}})
                    </option>
                {{/each}}
            </select>
            {{/SELECT}}
        </div>
    </div>
    {{/unless}}
    <div id="selectValuesInput">
        <div class="row">
            <div class="col-xs-12">
                {{#if selectedCategoryID}}
                {{TR "Lade Konfiguration..."}} <i class="fa fa-spin fa-spinner"></i>
                {{else}}
                <div class="alert alert-info m-t-20">
                    {{TR "Keine Gerätekategorie ausgewählt."}}
                </div>
                {{/if}}
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button id="js-btn-cancel" class="btn btn-white" data-dismiss="modal">
        {{TR "Abbrechen"}}
    </button>
    <button id="js-btn-save" class="btn btn-primary"{{#unless selectedCategoryID}} disabled{{/unless}}>
        {{TR "Speichern"}}
    </button>
</div>
